// @flow

import * as React from 'react';

import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import Input from '@mui/material/Input';
import useMediaQuery from '@mui/material/useMediaQuery';
import { useTheme } from '@mui/material/styles';

import i18n from 'app/common/i18n';
import Button from 'app/common/button';

class RefundPayment extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      modal: false,
      amount: 0,
      reason: ''
    };
  }

  handleClose = () => this.setState({ modal: false });

  handleClick = () => {
    if (this.props.confirmation) {
      return this.setState({ modal: true });
    }
    this.props?.onClick();
  };

  handleConfirmation = async () => {
    this.props?.onSubmit(
      this.props.payment.transaction,
      this.state.reason,
      this.state.amount
    );
    this.handleClose();
  };

  renderTriggerButton(label) {
    return (
      <Button
        flat
        secondary
        tabIndex={-1}
        label={label}
        onClick={this.handleClick}
      />
    );
  }

  render() {
    const label =
      this.props.payment.status !== 'CAPTURED'
        ? this.props.i18n('Check')
        : this.props.i18n('Refundere');

    if (this.props.confirmation) {
      const actions = this.state.password
        ? [
            <Button
              key="close"
              primary
              autoFocus
              label={this.props.i18n('Close')}
              onClick={this.handleClose}
              style={{ marginLeft: '12px' }}
            />
          ]
        : [
            <Button
              key="cancel"
              secondary
              flat
              label={this.props.i18n('Cancel')}
              onClick={this.handleClose}
              style={{ marginLeft: '12px' }}
            />,
            <Button
              key="submit"
              disabled={this.props.payment.status !== 'CAPTURED'}
              primary
              autoFocus
              label={this.props.i18n('Confirm')}
              onClick={this.handleConfirmation}
              style={{ marginLeft: '12px' }}
            />
          ];

      return this.state.modal ? (
        <>
          <Dialog
            open
            fullWidth
            fullScreen={this.props.fullScreen}
            onClose={this.handleClose}
            className="dialog-common"
          >
            <DialogTitle>{label}</DialogTitle>
            <DialogContent>
              <table style={{ width: '-webkit-fill-available' }}>
                <tbody>
                  <tr>
                    <td>Payment ID</td>
                    <td>{this.props.payment.transaction}</td>
                  </tr>
                  <tr>
                    <td>Payment amount</td>
                    <td>{this.props.payment.amount}</td>
                  </tr>
                  <tr>
                    <td>Payment status</td>
                    <td>{this.props.payment.status}</td>
                  </tr>
                  <tr>
                    <td>Product</td>
                    <td>{this.props.payment.product}</td>
                  </tr>
                </tbody>
              </table>
              <br />
              <br />
              {'Reason:'}
              <br />
              <textarea
                style={{ width: '-webkit-fill-available' }}
                rows={4}
                value={this.state.reason}
                onChange={(e) => {
                  this.setState({ reason: e.target.value });
                }}
              />
              <br />
              <br />
              {'Refund amount: (1 DKK = 100 / 480 DKK = 48000)'}
              <br />
              <Input
                type="number"
                value={this.state.amount}
                onChange={(e) => {
                  this.setState({ amount: e.target.value });
                }}
              />
              <br />
              <br />
            </DialogContent>
            <DialogActions>{actions}</DialogActions>
          </Dialog>
          {this.renderTriggerButton(label)}
        </>
      ) : (
        this.renderTriggerButton(label)
      );
    }

    return this.renderTriggerButton(label);
  }
}

const RefundPaymentI18n = i18n(RefundPayment);

function RefundPaymentWithMobileDialog(props) {
  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down('sm'));

  return <RefundPaymentI18n {...props} fullScreen={fullScreen} />;
}

export default RefundPaymentWithMobileDialog;